import { useState } from 'react';
import { cn } from '@/helpers/classnames';
import { useIntl } from 'react-intl';

export interface CreditInfoItem {
  label: string;
  bgColor: string;
  color: string;
  value: number;
  percentage: number;
}

export const CreditInfoBar = ({
  items,
  hideBar,
  className,
}: {
  items: CreditInfoItem[];
  hideBar?: boolean;
  className?: string;
}) => {
  const { locale } = useIntl();
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const getOpacity = (item: CreditInfoItem) => {
    if (hoveredItem === null || hoveredItem === item.label)
      return 'opacity-100';
    return 'opacity-50';
  };

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {!hideBar && (
        <div className="w-full">
          <div className="flex h-8 w-full overflow-hidden rounded-md border border-background-200 bg-background-200">
            {items.map((item) => (
              <div
                key={item.label}
                className={cn(
                  item.bgColor,
                  item.color,
                  'flex items-center justify-center text-xs font-medium transition-opacity duration-200',
                  getOpacity(item),
                )}
                style={{ width: `${item.percentage}%` }}
                title={`${item.label}: ${item.value.toLocaleString(locale)} SEK (${item.percentage.toFixed(1)}%)`}
                onMouseEnter={() => setHoveredItem(item.label)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                {item.percentage >= 20 && (
                  <span className="truncate px-1">
                    {item.value.toLocaleString(locale)} SEK
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-2 text-sm">
        {items.map((item) => (
          <div
            key={item.label}
            className={cn(
              'flex items-center gap-2 transition-opacity duration-200',
              getOpacity(item),
            )}
            onMouseEnter={() => {
              if (!hideBar) {
                setHoveredItem(item.label);
              }
            }}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className={cn('size-4 rounded', item.bgColor)} />
            <div className="min-w-0 flex-1">
              <div className="truncate font-medium">{item.label}</div>
              <div className="text-text-700">
                {item.value.toLocaleString(locale)} SEK{' '}
                {item.percentage === 0
                  ? ''
                  : `(${item.percentage.toFixed(1)}%)`}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
